// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HistoryType } from '../History/HistoryType';
import { DirectMessageBaseClass } from './DirectMessageBase';
export class DirectQuoteMessage extends DirectMessageBaseClass {
    constructor() {
        super(...arguments);
        this.PostProcessingMessage = null;
        this.TradingSession = null;
        this.OriginalSymbol = null;
        this.Type = HistoryType.DEFAULT;
        this.Time = null;
        this.SeriesGroupName = null;
        this.quoteAdditionalInfo = null;
        this.SessionFlag = null;
        this.Separated = false;
        this.InstrumentTradableID = null;
        this.IncomeQuoteTime = new Date();
        this.QuoteUniqueID = null;
        this.FRoute = '';
        this.symbol = null;
    }
    get Route() {
        return this.FRoute;
    }
    set Route(value) {
        this.FRoute = value;
    }
    // TODO: Remove cTime
    get cTime() {
        return this.Time;
    }
    set cTime(value) {
        this.Time = value;
    }
    get Symbol() {
        return this.symbol;
    }
    set Symbol(value) {
        if (value !== null) {
            this.symbol = value;
        }
    }
    SetSymbolIgnoreCase(symbol) {
        this.symbol = symbol;
    }
    // Копирую себя в передаваемую котировку
    CopyQuoteMsg(msg) {
        const qMsg = msg;
        const keys = Object.keys(this);
        // TODO подумать
        for (let i = 0; i < keys.length; i++) {
            qMsg[keys[i]] = this[keys[i]];
        }
        // qMsg.code = this.code;
        // qMsg.FRoute = this.FRoute;
        qMsg.SetSymbolIgnoreCase(this.symbol);
        // TODO Check
        qMsg.QuoteUniqueID = this.QuoteUniqueID;
        qMsg.QuoteType = this.QuoteType;
        // qMsg.Type = this.Type;
        // qMsg.cTime = this.cTime;
        // qMsg.OriginalSymbol = this.OriginalSymbol;
        // qMsg.SessionFlag = this.SessionFlag;
        // qMsg.Separated = this.Separated;
        // qMsg.VendorName = this.VendorName;
        // qMsg.SeriesGroupName = this.SeriesGroupName;
        // qMsg.InstrumentTradableID = this.InstrumentTradableID;
    }
    GetKey() {
        return (this.ExpDay.toString() + this.ExpMonth.toString() + this.ExpYear.toString() + this.StrikePrice.toFixed(5));
    }
    static IsArtificalType(type) {
        return type >= 1000;
    }
}
